import user from './user';
import projectSetting from './project-setting';
import common from './common';
import activity from './activity';
import app from './app';
import label from './label';
import resource from './resource';
import content from './content';
import book from './book';
import textToSpeech from './textToSpeech';

export default [
  user,
  common,
  projectSetting,
  activity,
  app,
  label,
  book,
  resource,
  content,
  textToSpeech
];
